<script>
  import Footer from '../components/Footer.svelte';
  import Header from '../components/Header.svelte';
  import Reveal from '../components/Reveal.svelte';
  import AboutSection from '../sections/AboutSection.svelte';
  import ExpertsSection from '../sections/ExpertsSection.svelte';
  import FaqSection from '../sections/FaqSection.svelte';
  import HeroSection from '../sections/HeroSection.svelte';
  import PartnersSection from '../sections/PartnersSection.svelte';
  import ParticipateSection from '../sections/ParticipateSection.svelte';
  import ProgramSection from '../sections/ProgramSection.svelte';
  import TeamSection from '../sections/TeamSection.svelte';
</script>

<div id="top" class="landing-page">
  <Header />
  <HeroSection />

  <main class="landing-main">
    <Reveal><AboutSection /></Reveal>
    <Reveal><PartnersSection /></Reveal>
    <Reveal><ProgramSection /></Reveal>
    <Reveal><ExpertsSection /></Reveal>
    <Reveal><TeamSection /></Reveal>
    <Reveal><ParticipateSection /></Reveal>
    <Reveal><FaqSection /></Reveal>
  </main>

  <Footer />
</div>

<style>
  .landing-page {
    position: relative;
    min-height: 100vh;
    background: #000000;
    color: #111111;
  }

  .landing-main {
    display: flex;
    width: 100%;
    flex-direction: column;
    margin: 0 auto;
  }
</style>
